import { useEffect, useRef } from "react"
import { useAnalytics } from "connected-components/analytics"
import { DASHBOARD_EVENTS } from "../events"

export function useModelChangeTracking(modelId: string) {
  const analytics = useAnalytics()
  const previousModelId = useRef<string | undefined>(undefined)

  useEffect(() => {
    if (modelId && previousModelId.current && modelId !== previousModelId.current) {
      analytics.track(DASHBOARD_EVENTS.MODEL_CHANGED, {
        oldModelId: previousModelId.current,
        newModelId: modelId,
      })
    }
    previousModelId.current = modelId
  }, [analytics, modelId])
}
